import React from 'react'
import './Footer.scss'
import { BiLogoEtsy } from "react-icons/bi";
import { ImYoutube2 } from "react-icons/im";
// import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='footer'>

      <div className='footer_Middle'>
            <Link to='/about' className='footer-privacy-policy'>About</Link>
            <span style={{color:'rgba(255,244,212,0.4)', margin:'0 8px'}}>·</span>
            <Link to='/privacypolicy' className='footer-privacy-policy'>© 2026 Punjabi Academy · Privacy Policy</Link>
      </div>
      <div className='footer_Right'>
          <a href='https://www.etsy.com/shop/PunjabiLearningHub?ref=seller-platform-mcnav' className='footer-right-etsy'><BiLogoEtsy /></a>
          <a href='https://youtube.com/@punjabilearninghub?si=0BpICzbhok5gm1OA' className='footer-right-youtube'><ImYoutube2 /></a>
          <a href='https://www.tiktok.com/@punjabilearninghub?is_from_webapp=1&sender_device=pc' className='footer-right-tiktok'><FaTiktok /></a>
      </div>
    </div>
  )
}

export default Footer


